
import React from "react";
import { Link } from "react-router-dom";
import { Play } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";

const QuickActions: React.FC = () => {
  const { t } = useTranslation('dashboard');
  
  return (
    <div className="mb-8">
      <div className="flex justify-start">
        <Button 
          className="h-12 text-sm font-medium flex items-center bg-golf-600 hover:bg-golf-700" 
          asChild
        >
          <Link to="/training">
            <Play className="h-4 w-4 mr-2" />
            <span>{t('actions.startTraining')}</span>
          </Link>
        </Button>
      </div>
    </div>
  );
};

export default QuickActions;
